import React from 'react';
import { Route } from 'react-router-dom';
import ChooseAccommodation from 'routes/ChooseAccommodation';
import DateSelection from 'routes/DateSelection';
import GuestInformation from 'routes/GuestInformation';
import ReviewAndSubmit from 'routes/ReviewAndSubmit';
import Confirmation from 'routes/Confirmation';
import { getBookingEnginePath } from 'utils/routeUtils';
import { Redirect } from 'react-router';

export default [
  <Route
    key={'date-selection'}
    exact
    path={getBookingEnginePath()}
    component={DateSelection}
  />,
  <Route
    key={'choose-accommodation'}
    exact
    path={getBookingEnginePath('choose-accommodation')}
    component={ChooseAccommodation}
  />,
  <Route
    key={'guest-information'}
    exact
    path={getBookingEnginePath('guest-information')}
    component={GuestInformation}
  />,
  <Route
    key={'review'}
    exact
    path={getBookingEnginePath('review')}
    component={ReviewAndSubmit}
  />,
  <Route
    key={'confirmation'}
    exact
    path={getBookingEnginePath('confirmation/:id?')}
    component={Confirmation}
  />,
  // Temporary redirect in place until all references are updated to use / instead of /booking-engine.
  <Redirect
    key={'redirect-old-route'}
    from={'/booking-engine'}
    to={getBookingEnginePath()}
  />
];
